<template>
  <div
    class="lightingYOMWrap mainPageBg"
    v-loading="$store.state.user.loadingState"
  >
    <div class="selectWrap commonWrap">
      <LightingMenu @getSelectData="getSelectData" />
    </div>
    <div class="chartWrap">
      <div class="containerBox commonWrap">
        <div class="commonWrap contentWrap">
          <div class="commonTitle">
            <h4><span>1</span>同比分析</h4>
          </div>

          <div class="commonContentBox">
            <YOMCharts :id="'myCharts'" :chartsData="yoyData" />
          </div>
        </div>
        <div class="tolWrap">
          <div
            class="proportion"
            :style="{
              background: yoyCard.bgColor,
              color: yoyCard.color,
            }"
          >
            {{ yoyCard.yoy }}
            <span style="display: inline-block; height: 40%; margin-left: 10px"
              ><img :src="require('@/assets/images/' + yoyCard.type + '.png')"
            /></span>
          </div>
          <div class="cumulative">
            <ul>
              <li>
                <div>本期平均照度</div>
                <h3 style="color: #377afe">{{ yoyCard.thisYear }} lx</h3>
              </li>
              <li>
                <div>去年同期平均照度</div>
                <h3 style="color: #ff9533">{{ yoyCard.lastYear }} lx</h3>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="containerBox commonWrap">
        <div class="commonWrap contentWrap">
          <div class="commonTitle">
            <h4><span>1</span>环比分析</h4>
          </div>

          <div class="commonContentBox">
            <YOMCharts :id="'myCharts1'" :chartsData="momData" />
          </div>
        </div>
        <div class="tolWrap">
          <div
            class="proportion"
            :style="{
              background: momCard.bgColor,
              color: momCard.color,
            }"
          >
            {{ momCard.mom }}
            <span style="display: inline-block; height: 40%; margin-left: 10px"
              ><img :src="require('@/assets/images/' + momCard.type + '.png')"
            /></span>
          </div>
          <div class="cumulative">
            <ul>
              <li>
                <div>本期平均照度</div>
                <h3 style="color: #377afe">{{ momCard.thisPeriod }} lx</h3>
              </li>
              <li>
                <div>上期平均照度</div>
                <h3 style="color: #ff9533">{{ momCard.lastPeriod }} lx</h3>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import YOMCharts from "@/components/zixitong/lightingSystem/YOMCharts";
import LightingMenu from "@/components/zixitong/lightingSystem/LightingMenu";
import api from "@/api";
import { dateFtt } from "@/assets/js/utils";
export default {
  components: {
    YOMCharts,
    LightingMenu,
  },
  data() {
    return {
      yoyData: {},
      momData: {},
      yoyCard: {
        type: "flat",
      },
      momCard: {
        type: "flat",
      },
    };
  },
  methods: {
    getSelectData(data) {
      let interval = 0;
      if (data.showX == "小时") interval = 3600;
      if (data.showX == "天") interval = 3600 * 24;
      this.$store.commit("SET_LOADING", true);
      return new Promise(async (resolve) => {
        let res = await api.subsystemYoyMomInfo({
          beginTime: data.timeData[0],
          endTime: data.timeData[1],
          id: data.defaultId,
          interval: interval,
        });
        // console.log(res.data);
        if (res && res.status == 200) {
          this.$store.commit("SET_LOADING", false);
          this.yoyData = {
            unit: "",
            xData: [],
            yearArr: [],
            lastYearArr: [],
          };
          this.momData = {
            unit: "",
            xData: [],
            yearArr: [],
            lastYearArr: [],
          };
          this.yoyCard = res.data.yoy.average;
          this.momCard = res.data.mom.average;

          if (parseFloat(this.yoyCard.yoy.slice(0, -1)) > 0) {
            this.yoyCard.type = "gup";
            this.yoyCard.bgColor = "rgba(246, 65, 71, 0.2)";
            this.yoyCard.color = "#F64147";
          } else if (parseFloat(this.yoyCard.yoy.slice(0, -1)) == 0) {
            this.yoyCard.type = "flat";
            this.yoyCard.bgColor = "#fff";
            this.yoyCard.color = "#333";
          } else if (parseFloat(this.yoyCard.yoy.slice(0, -1)) < 0) {
            this.yoyCard.type = "gdown";
            this.yoyCard.bgColor = "#effff5";
            this.yoyCard.color = "#27df7c";
          }
          if (parseFloat(this.momCard.mom.slice(0, -1)) > 0) {
            this.momCard.type = "gup";
            this.momCard.bgColor = "rgba(246, 65, 71, 0.2)";
            this.momCard.color = "#F64147";
          } else if (parseFloat(this.momCard.mom.slice(0, -1)) == 0) {
            this.momCard.type = "flat";
            this.momCard.bgColor = "#fff";
            this.momCard.color = "#333";
          } else if (parseFloat(this.momCard.mom.slice(0, -1)) < 0) {
            this.momCard.type = "gdown";
            this.momCard.bgColor = "#effff5";
            this.momCard.color = "#27df7c";
          }

          this.yoyData.unit = res.data.yoy.thisYear[0].unit;
          this.momData.unit = res.data.mom.thisPeriod[0].unit;
          res.data.yoy.thisYear.forEach((v, i) => {
            this.yoyData.xData.push(v.time);
            this.yoyData.yearArr.push(v.value);
            this.yoyData.lastYearArr.push(res.data.yoy.lastYear[i].value);
          });
          res.data.mom.thisPeriod.forEach((v, i) => {
            this.momData.xData.push(v.time);
            this.momData.yearArr.push(v.value);
            this.momData.lastYearArr.push(res.data.mom.lastPeriod[i].value);
          });
        }

        resolve();
      });
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.lightingYOMWrap {
  @include setFlexColumn;
  justify-content: space-around;
  .selectWrap {
    width: 96%;
    height: 80px;
    margin: 10px auto 0;
    @include setFlexBetween;
    justify-content: flex-start;
  }
  .chartWrap {
    width: 96%;
    height: calc(100% - 135px);
    margin: 10px auto;
    @include setFlexColumn;
    justify-content: space-between;
    .containerBox {
      height: 48%;
      @include setFlexBetween;
      .contentWrap {
        width: 78%;
        height: 100%;
        overflow: hidden;
      }
      .tolWrap {
        width: 20%;
        height: 90%;
        margin-right: 2%;
        background: #ffffff;
        border-radius: 20px;
        box-shadow: 0px 0px 26px 0px rgba(51, 51, 51, 0.1);
        overflow: hidden;
        .proportion {
          height: 34%;
          width: 100%;
          background: #effff5;
          @include setFlexCenter;
          font-size: 36px;
          font-weight: bold;
          color: #27df7c;
          img {
            width: 100%;
          }
        }
        .cumulative {
          height: 66%;
          width: 100%;
          ul {
            margin: 0 20px;
            height: 100%;
            width: 100%;
            li {
              height: 45%;
              @include setFlexColumn;
              justify-content: center;
              div {
                font-size: 16px;
              }
              h3 {
                margin-top: 5px;
                font-size: 32px;
                span {
                  display: inline-block;
                  font-size: 14px;
                }
              }
            }
            li:nth-child(1) {
              border-bottom: 1px solid #ebebeb;
            }
          }
        }
      }
    }
  }
}
</style>